<template>
  <div class="card-site">
    <div class="card-header" v-if="!noHeader">
      <slot name="header-content"></slot>
    </div>
    <div class="card-body">
      <slot name="body-content"></slot>
    </div>
    <div class="card-footer" v-if="!noFooter">
      <slot name="footer-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
    noFooter: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style></style>
